module.exports = __webpack_public_path__ + "static/media/fangxiang2.73c5bad1.png";